import React from "react";
import { useRoutePath } from "../../../../../util/Routing";
import { EntityDetailPage } from "../shared/EntityDetailPage";

export function DistributorDetailPage(): JSX.Element {
  const { adminPath } = useRoutePath();
  return (
    <EntityDetailPage
      entityType="distributor"
      listPath={`${adminPath}/mdm/distributors`}
    />
  );
}
